import React from "react";
import styled from "styled-components";

import Layout from "@components/Layout";
import PartnerProductsAddForm from "./PartnerProductsAddForm";

import { Container } from "@styles/grid";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 5.5rem 5.5rem;
`;

const PartnerProductsAdd = () => {
  return (
    <Layout pageTitle="Add Partner Product">
      <Container>
        <Content>
          <PartnerProductsAddForm />
        </Content>
      </Container>
    </Layout>
  );
};

export default PartnerProductsAdd;
